module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.collection.persistedCount() < this.totalCount) {
        $o.push("" + $e($c((this.collection.persistedCount()) + " of ")));
      }
      $o.push("" + $e($c(this.inflector.pluralize("total project", this.totalCount))));
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/projects_count.js.hamlc
// module id = 302
// module chunks = 15